import React from 'react'
import type { Icon } from 'shared/utils'

const CircleFaq = (props: Icon) => {
    const {
        color = '#BB1E32',
        background = 'white',
        size = 80,
        className = 'circle-faq'
    } = props
    return (
        <svg width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={38.5}
                    stroke={background}
                    strokeWidth={3}
                />
                <path
                    fill={background}
                    fillRule="nonzero"
                    d="M54.706 25.243c-8.15-8.122-21.341-8.099-29.463.051s-8.099 21.341.051 29.463c8.13 8.102 21.282 8.102 29.412 0 8.15-8.122 8.173-21.313.051-29.463a20.834 20.834 0 0 0-.051-.05z"
                />
                <path
                    fill={color}
                    d="M39.48 47.422a1.953 1.953 0 1 1 0 3.905 1.953 1.953 0 0 1 0-3.905zm.074-1.953a1.981 1.981 0 0 1-1.972-1.99c0-2.647 2.321-4.662 4.59-6.285.707-.506 1.486-2.179 1.05-3.551-.432-1.355-2.14-2.163-3.542-2.163h-.001c-1.538 0-3.447.723-4.19 2.744a1.968 1.968 0 0 1-2.536 1.171 1.993 1.993 0 0 1-1.162-2.558c1.193-3.24 4.289-5.337 7.888-5.337h.003c2.848 0 6.269 1.69 7.298 4.925.994 3.125-.536 6.593-2.524 8.013-2.644 1.89-2.93 2.757-2.93 3.042a1.98 1.98 0 0 1-1.972 1.989z"
                />
            </g>
        </svg>
    )
}

export { CircleFaq }
